// src/components/AuthWrapper.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Button, Title, Text } from "rizzui";
// import { PiAppleLogoFill, PiArrowLeftBold } from "react-icons/pi"
// import { FcGoogle } from "react-icons/fc"
import toast from "react-hot-toast";

interface AuthWrapperProps {
  children: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  isSocialLoginActive?: boolean;
}

export default function AuthWrapper({
  children,
  title,
  // description,
  // isSocialLoginActive = false,
}: AuthWrapperProps) {
  const handleSignIn = () => {
    toast.error(
      <Text>
        This is only demo purpose, click on the{" "}
        <Text as="b" className="font-semibold text-gray-900">
          Sign In
        </Text>{" "}
        button to login.
      </Text>
    );
  };

  return (
    <div className="min-h-screen flex flex-col justify-between gap-x-8 p-4 pt-10 lg:flex-row lg:p-6 xl:gap-x-10 2xl:p-10">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="w-full max-w-sm md:max-w-md lg:py-7 lg:pl-3 lg:pt-16 2xl:w-[630px] 2xl:pl-20 2xl:pt-7">
          <div className="mb-7 flex flex-col items-center px-6 pt-3 text-center md:pt-0 lg:px-0 xl:mb-8 2xl:mb-10">
            <Link to="/" className="mb-6 inline-flex max-w-[168px] xl:mb-8">
              <img
                src="/owo2.svg"
                alt="OwoHQ Logo"
                width={50}
                height={50}
                className="inline-block"
              />
            </Link>
            <Title
              as="h2"
              className="mb-5 text-[26px] leading-snug md:text-3xl lg:mb-7 lg:px-4 xl:text-3xl 2xl:text-4xl"
            >
              {title}
            </Title>
            {/* {description && (
              <Text className="leading-[1.85] text-gray-700 md:leading-loose lg:px-8 2xl:px-14">
                {description}
              </Text>
            )} */}
          </div>

          {/* {isSocialLoginActive && (
            <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2 xl:gap-5">
              <Button
                onClick={handleSignIn}
                variant="outline"
                className="h-11 w-full"
              >
                <PiAppleLogoFill className="mr-2 h-4 w-4" />
                Sign in with Apple
              </Button>
              <Button
                onClick={handleSignIn}
                variant="outline"
                className="h-11 w-full"
              >
                <FcGoogle className="mr-2 h-4 w-4" />
                Sign in with Google
              </Button>
            </div>
          )} */}

          {children}
        </div>
      </div>
    </div>
  );
}
